import React from 'react';
import './DWDModal.module.css'
import { BUTTON_TYPES } from '../../Constants';
import DWDButton from '../DWDButton/DWDButton';
import { Box, FormControlLabel, Modal, Radio, RadioGroup, TextareaAutosize, Typography, IconButton } from '@mui/material';
import {Tooltip as MatTooltip} from '@mui/material';
import { Col, Row, Tooltip } from 'react-bootstrap';
import CloseIcon from "@mui/icons-material/Close";
import TreeVisualization from '../../../Pages/UaeMt/DataTree/DataTree';
import homebtn from '../../../Assets/Images/homebtn.png';

export interface DWDModalProps {
    show?: boolean;
    handleClose?: () => any;
    handleShow?: () => any;
    inputRunId?: string;
    descriptionType?: string;
    handleChange?: (event: any) => any;
    modalName: string;
    // resData: string;
}
const logoutStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const FeedbackStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const DataTreeStyle = {
    position: 'absolute',
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
}
const DWDModal = ({ show, handleClose, handleShow, handleChange, modalName}: DWDModalProps) => {
    const handleSubmit = () => handleShow && handleShow();
    const handleCancle = () => handleClose && handleClose();

    const [isValidAnswer, setIsValidAnswer] = React.useState(true);
    const [isFormatValue, setIsFormatValue] = React.useState(true);
    const [otherComments, setOtherComments] = React.useState("");
    const [expectedAnswer, setExpectedAnswer] = React.useState("");
    const [expectedFormat, setExpectedFormat] = React.useState("");


    const handleFeedbackSubmission = (event: any) => {
        handleChange && handleChange({
            accurate_ans: isValidAnswer,
            correct_format: expectedFormat,
            correct_sql: expectedAnswer,
            expected_format: isFormatValue,
            other_comments: otherComments
        });
        setExpectedAnswer("");
        setExpectedFormat("");
        setOtherComments("");
    }
    const handleAnswerChange = () => {
        setIsValidAnswer(!isValidAnswer);
        if (!isValidAnswer) {
            setExpectedAnswer("");
        }
    };
    const handleFormatChange = () => {
        setIsFormatValue(!isFormatValue);
        if (!isValidAnswer) {
            setExpectedFormat("");
        }
    };

    const handleExpectedAnswer = (event: any) => {
        setExpectedAnswer(event.target.value);
    };
    const handleExpectedFormat = (event: any) => {
        setExpectedFormat(event.target.value);
    };
    const handleOtherComments = (event: any) => {
        setOtherComments(event.target.value);
    };
    return (
        <>
            {modalName == "logout" && <Modal
                open={show!}
                onClose={handleCancle}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={logoutStyle}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        Logout
                    </Typography>
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                        <div><p className='ml20'> Are you sure, Do you want to logout?</p>
                        </div>
                        <div className='floatRight'>

                            <DWDButton title='No ' className='closeBtn width100px' handleClick={handleCancle} type={BUTTON_TYPES.TYPE_1} />

                            <DWDButton title='Yes' className={'successBtn width100px ml10'} handleClick={handleSubmit} type={BUTTON_TYPES.TYPE_1} />

                        </div>
                    </Typography>
                </Box>
            </Modal>}

            {modalName == "feedback" && <Modal
                open={show!}
                onClose={handleCancle}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"


            >
                <Box sx={FeedbackStyle} style={{ width: " !important" }} className={'feedbackContainer'}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            Feedback
                        </Typography>
                        <IconButton
                            aria-label="close"
                            onClick={handleCancle}
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>

                    <Typography id="modal-modal-description" className='f12px'>
                        <div>
                            <p> Can you invest few seconds to share your valuable feedback: </p>
                            <Row style={{ alignItems: "center" }}>
                                <Col>Accurate Answer: </Col>
                                <Col>
                                    <RadioGroup
                                        row
                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                        name="row-radio-buttons-group"
                                        value={isValidAnswer}
                                        onChange={handleAnswerChange}
                                    >
                                        <FormControlLabel value={true} control={<Radio sx={{
                                            '& .MuiSvgIcon-root': {
                                                fontSize: 12,
                                            },
                                        }} />} label={<span style={{ fontSize: '12px' }}>Yes</span>} />
                                        <FormControlLabel value={false} control={<Radio sx={{
                                            '& .MuiSvgIcon-root': {
                                                fontSize: 12,
                                            },
                                        }} />} label={<span style={{ fontSize: '12px' }}>No</span>} />
                                    </RadioGroup>
                                </Col>
                            </Row>
                            {!isValidAnswer && <Row>
                                <Col>Please provide the expected Answer:</Col>
                                <Col> <TextareaAutosize aria-label="empty textarea" placeholder="Please enter expected Answer" className='customTextArea' minRows={3}
                                    defaultValue={expectedAnswer}
                                    onChange={handleExpectedAnswer}
                                /></Col>
                            </Row>}
                            <Row style={{ alignItems: "center" }}>
                                <Col>Answer Format As Expected:</Col>
                                <Col><RadioGroup
                                    row
                                    aria-labelledby="demo-row-radio-buttons-group-label"
                                    name="row-radio-buttons-group"
                                    value={isFormatValue}
                                    onChange={handleFormatChange}
                                >
                                    <FormControlLabel value={true} control={<Radio sx={{
                                        '& .MuiSvgIcon-root': {
                                            fontSize: 12,
                                        },
                                    }} />} label={<span style={{ fontSize: '12px' }}>Yes</span>} />
                                    <FormControlLabel value={false} control={<Radio sx={{
                                        '& .MuiSvgIcon-root': {
                                            fontSize: 12,
                                        },
                                    }} />} label={<span style={{ fontSize: '12px' }}>No</span>} />
                                </RadioGroup></Col>
                            </Row>
                            {!isFormatValue && <Row>
                                <Col>Please provide the expected Format:</Col>
                                <Col> <TextareaAutosize aria-label="empty textarea" placeholder="Please enter expected Format" className='customTextArea' minRows={3}
                                    defaultValue={expectedFormat}
                                    onChange={handleExpectedFormat}
                                /></Col>
                            </Row>}
                            <Row className='mt10'>
                                <Col>Any other comments:</Col>
                                <Col>
                                    <TextareaAutosize aria-label="empty textarea" placeholder="Please enter your comments here" className='customTextArea' minRows={3}
                                        defaultValue={otherComments}
                                        onChange={handleOtherComments} />
                                </Col>
                            </Row>
                        </div>
                        <div className='floatRight mt20'>

                            <DWDButton title='Cancel' className='closeBtn width100px' handleClick={handleCancle} type={BUTTON_TYPES.TYPE_1} />

                            <DWDButton title='Submit' className={otherComments === "" || (!isValidAnswer && expectedAnswer === "") || (!isFormatValue && expectedFormat === "") ? 'disableBtn successBtn width100px' : 'successBtn width100px ml10'} handleClick={handleFeedbackSubmission} type={BUTTON_TYPES.TYPE_1} isDisable={otherComments === "" || (!isValidAnswer && expectedAnswer === "") || (!isFormatValue && expectedFormat === "")} />

                        </div>
                    </Typography>
                </Box>
            </Modal>}
            {modalName == "DataTree" && <Modal
                open={show!}
                onClose={handleCancle}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={DataTreeStyle} style={{ width: " !important" }} className={'dataTreeContainer'}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <button className='bckSummary' onClick={handleClose}>
                            <MatTooltip title='Back to Summary'>
                                <img src={homebtn} alt='home'/>
                            </MatTooltip>
                        </button>
                        {/* <Tooltip title="Close" placement="top">
                            <Button>Close</Button>
                        </Tooltip> */}
                        
                        <TreeVisualization/>
                        
                    </div>
                    
                </Box>
            </Modal>}
        </>
    );
}

export default DWDModal;

